import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/NC-Logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3de68140"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main-top-nav",
  class: "text-sm text-primary-contrast font-bold h-nav-small"
}
const _hoisted_2 = { class: "flex max-w-body-width mx-auto justify-end h-full" }
const _hoisted_3 = ["href", "onMouseenter"]
const _hoisted_4 = { class: "flex max-w-body-width mx-auto h-full items-center justify-end" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  alt: "firmenlogo",
  class: "h-full",
  src: _imports_0
}, null, -1))
const _hoisted_6 = ["onMouseenter"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "m-auto group-hover:font-bold" }
const _hoisted_9 = { class: "flex flex-col mx-md py-standard border-border border-t-2" }
const _hoisted_10 = { class: "my-standard text-center transition-all duration-300 hover:font-bold hover:text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "main-nav",
    class: _normalizeClass(["absolute top-0 w-screen z-10 transition-all duration-300", { 'nav-collapsed': _ctx.isScrolledDown }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subNavItems, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.ID
          }, [
            (item.type === 'custom')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.url,
                  target: "_blank",
                  class: _normalizeClass(["mx-5 my-auto justify-self-end hover:underline", { 'nav-cta': item.description === 'CTA' }]),
                  onMouseenter: ($event: any) => (_ctx.onNavHover(item))
                }, _toDisplayString(item.title), 43, _hoisted_3))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: item.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''),
                  class: "main-nav-link mx-5 my-auto justify-self-end hover:underline",
                  onMouseenter: ($event: any) => (_ctx.onNavHover(item)),
                  onClick: _withModifiers(($event: any) => (
              _ctx.onNavLeave(item.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''))
            ), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "onMouseenter", "onClick"]))
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      id: "main-bottom-nav",
      class: _normalizeClass(["bg-background text-black h-nav", { 'nav-collapsed': _ctx.isScrolledDown }])
    }, [
      _createElementVNode("nav", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "mr-auto h-full",
          to: "/",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNavHover({})))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainNavItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.ID,
            class: "relative flex h-full transition-all duration-300 cursor-pointer hover:bg-background-darker group px-8",
            onMouseenter: ($event: any) => (_ctx.onNavHover(item)),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNavLeave()))
          }, [
            (item.type === 'custom')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.url,
                  target: "_blank",
                  class: "flex flex-grow justify-self-end hover:underline"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["m-auto transition-all duration-300", { 'font-bold': _ctx.hoveredNavItem === item }])
                  }, _toDisplayString(item.title), 3)
                ], 8, _hoisted_7))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: item.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''),
                  class: "m-auto",
                  onClick: _withModifiers(($event: any) => (
                _ctx.onNavLeave(
                  item.url.replace(/^https:\/\/wpdev.netconnect.ch/, '')
                )
              ), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"])),
            (item.child_items && item.child_items.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["absolute top-full left-0 right-0 bg-background-darker overflow-hidden transition-all duration-300", {
                'max-h-0 opacity-0': _ctx.hoveredNavItem !== item,
                'max-h-md-image opacity-100': _ctx.hoveredNavItem === item
              }]),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNavLeave()))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child_items, (child) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: child.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''),
                        key: child.ID,
                        class: "mx-auto",
                        onMouseenter: ($event: any) => (_ctx.onNavChildHover(child)),
                        onClick: _withModifiers(($event: any) => (
                    _ctx.onNavLeave(
                      child.url.replace(/^https:\/\/wpdev.netconnect.ch/, '')
                    )
                  ), ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(child.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "onMouseenter", "onClick"]))
                    }), 128))
                  ])
                ], 34))
              : _createCommentVNode("", true)
          ], 40, _hoisted_6))
        }), 128))
      ])
    ], 2)
  ], 2))
}